import {AfterViewInit, Component, OnDestroy, OnInit, DoCheck} from '@angular/core';
import {FchartalgoService} from '../fchart/fchartalgo.service';
import {StaticService} from '../consulta/static.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import {distinctUntilChanged, debounceTime, takeWhile} from 'rxjs/operators';
import {pipe} from 'rxjs/util/pipe';

@Component({
  selector: 'app-opciones',
  templateUrl: './opciones.component.html',
  styleUrls: ['./opciones.component.scss']
})
export class OpcionesComponent implements OnInit, AfterViewInit, OnDestroy, DoCheck {

  param;
  subscriptionToInputs = true;
  inputArray: HTMLInputElement[ ] = [];
  inputValues: number[] = [100,100,100,100,100,100,100,100,100,100,100,100];


  offerloaded = null;
  selectedCaptador = null;
  ForzadoSelected = false;

  solo_forzado = ['GREENSUN 2,2 HS','GREENSUN 2,2 VS','GREENSUN 2,6 HS','GREENSUN 2,6 VS', 'HELIOPLAN S','HELIOPLAN S MINI','KAPLAN 2,2 H'];


  constructor(private fchartalgo: FchartalgoService, private staticS:StaticService) { }

  ngOnInit() {
    this.param = this.staticS.getDefaultOptionsParam();
    this.updateOnchangeOptions();
  }

  ngDoCheck() {
    if(this.offerloaded != this.staticS.getSelectedOffer()){
      this.offerloaded = this.staticS.getSelectedOffer();
      if (this.offerloaded){
        this.setLoadedParams();
        this.updateOnchangeOptions();
      }
      else {
        this.param = this.staticS.getDefaultOptionsParam();
        for (var i = 0; i < this.inputArray.length; i++){
          this.inputValues[i] = 100;
          var input = document.getElementById('input-'+i) as HTMLInputElement;
          input.value = input.max;
        }
        this.updateOnchangeOptions();
      }
    }
    if (this.selectedCaptador != this.fchartalgo.getSelectedCaptador()){
      this.selectedCaptador = this.fchartalgo.getSelectedCaptador();
      this.ForzadoSelected = false;
      this.param.forzado = false;
      for(var i = 0; i < this.solo_forzado.length; i++){
        if (this.selectedCaptador.Captador ==  this.solo_forzado[i]){
          this.ForzadoSelected = true;
          this.param.forzado = true;
          //console.log(this.selectedCaptador.Captador);
          break;
        }
      }
    }
  }

  setLoadedParams(){
    var arr = this.offerloaded.occupancy_percentage.split(',');
    for (var i = 0; i < this.inputArray.length; i++){
      this.inputValues[i] = arr[i];
      var input = document.getElementById('input-'+i) as HTMLInputElement;
      input.value = arr[i];
    }
    this.param.c_plana = this.offerloaded.c_plana;
    this.param.centralization = this.offerloaded.centralization;
    this.param.forzado = this.offerloaded.forzado;
  }

  ngAfterViewInit() {
    for (let i = 0; i < 12; i++ ) {
      const input = document.getElementById('input-' + i) as HTMLInputElement;
      this.inputArray.push(input);
      this.inputValues = [100,100,100,100,100,100,100,100,100,100,100,100];
      const input$ = Observable
        .fromEvent(input, 'change')
        .pipe(
          takeWhile(() => this.subscriptionToInputs),
          distinctUntilChanged(),
          debounceTime(200) // se espera 200ms
        )
        .subscribe((event: Event) => this.onSliderValueChanges(i, event.target['value']));
    }
  }

  onSliderValueChanges(index, value) {
    this.inputValues[index] = parseInt(value, 10);
  }

  updateOnchangeOptions() {
    if (this.param.desviacion > 360)
      this.param.desviacion = this.param.desviacion - ((this.param.desviacion % 360)*360);
    this.fchartalgo.updateOccupancy(this.inputValues);
    this.fchartalgo.setOptions(this.param);
    this.fchartalgo.calculateAll();
  }

  ngOnDestroy() {
    this.subscriptionToInputs = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/opciones/opciones.component.ts